import { ID } from './config';

/* eslint-disable import/prefer-default-export */

export const previousPathnameSelector = ({
    [ID]: {
        location,
    },
}) => location && location.previousPathname;
